module.exports = __webpack_public_path__ + "img/master.90ffa928.svg";